import { cn } from "utils/helpers";

type BidderQuestionnaireHeaderProps = {
	description?: string;
	error?: string;
	question: string;
	required?: boolean;
	touchedField?: boolean;
};

export const BidderQuestionnaireHeader = ({
	question,
	required,
	description,
	error,
	touchedField,
}: BidderQuestionnaireHeaderProps) => {
	return (
		<>
			<h3 className="whitespace-pre-line text-lg font-semibold text-secondary-700">
				{question}
				<span
					className={cn(
						"font-normal text-tertiary-600",
						error && touchedField && "font-semibold text-red-600"
					)}
				>
					{required ? <span className="text-red-600">{`*`}</span> : null}
					{required ? " (Required)" : " (Optional)"}
				</span>
			</h3>
			{description ? (
				<p className="text-wrap text-sm text-tertiary-600">{description}</p>
			) : null}
		</>
	);
};
